import React from 'react';
import { Button, Carousel, Container } from 'react-bootstrap';
import { BiLinkExternal } from 'react-icons/bi';
import Particle from '../../Particle';
import shebaHome from "../../../Images/Project/sheba/sheba-home.JPG";
import shebaService from "../../../Images/Project/sheba/sheba-services.JPG";
import shebaDept from "../../../Images/Project/sheba/sheba-serv.JPG";
import shebaForm from "../../../Images/Project/sheba/sheba-form.JPG";

const Sheba = () => {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    Sheba Care <strong className="purple"> Website </strong>
                </h1>
                <div className='mt-5 mb-5'>
                    <div className='container '>
                        <div className='row '>
                            <div className='col-lg-6 col-sm-12'>
                                <Carousel fade>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={shebaHome}
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={shebaService}
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={shebaDept}
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={shebaForm}
                                            alt="fourth slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <p className='fw-bold text-white'>This is a Hospital related Website. User can Choice the Medical services that they wants. User can Login via Google sign, Github and Creating free account with Email. </p>

                                <p className='text-white'>
                                    <ul>
                                        <li>Users can book an appointment for a medical service.</li>
                                        <li>Appointment will be saved in DataBase.</li>
                                        <li>User Can Create an Account and Login Via firebase authentication</li>
                                    </ul></p>
                                <p className='text-white'> Front-end technology: React js, Bootstrap,React Router, Firebase Authentication</p>
                                <p className='text-white'> Back-end technology: Node js,Express js, MongoDB</p>
                                <Button href='https://github.com/nhnajmul17/Sheba-Care' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Client Side</Button>

                                <Button href='https://sheba-care.web.app/' className='btn btn-info'>  <BiLinkExternal /> &nbsp;Live Site</Button>

                            </div>

                        </div>

                    </div>


                </div>


            </Container>
        </Container>
    );
};

export default Sheba;